import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Page } from '../../ui';
import { useHasRequiredLevel, useUserRole } from '../auth/hooks';
import { CONTENT_STANDARD, media } from '../../utils/media';
import { useTranslation } from 'react-i18next';
import PageControls from '../../ui/Page/PageControls';
import MyCoursesList from './components/MyCoursesList';
import WelcomeMessage from './components/WelcomeMessage';
import WelcomeRow from './components/WelcomeRow';
import LearningProgressOverview from './components/student/LearningProgressOverview';
import TeacherOverviewWidget from './components/teacher/TeacherOverviewWidget';
import { MOCK_COURSE_STATS } from './components/teacher/mockTeacherData';
import { selectCartItemsCount } from '../webshop/cartSlice';
import MyTeachingList from './components/MyTeachingList';
import ListCourses from '../../components/ListCourses';
import NetworkSuggestions from '../../components/CoursioNetwork';
import NetworkUpsells from '../../components/CoursioNetwork/NetworkUpsells';
import { useFeatures } from '../settings/hooks';
import PageSection from '../../ui/Page/PageSection';

const HeaderSearch = styled.div`
  position: absolute;
  top: 8px;
  right: ${({ $hasExtraMargem }) => (!$hasExtraMargem ? '8px' : '64px')};
  z-index: 1200;
  ${media.greaterThan('laptop')} {
    right: 20px;
  }
`;

const DashboardContent = ({ clearSearch, searchQuery, handleSearch, dashboardData, isLoading }) => {
  const { t } = useTranslation();
  const features = useFeatures();
  const cartItemsCount = useSelector(selectCartItemsCount);
  const isOwner = useHasRequiredLevel('owner');
  const isTeacher = useHasRequiredLevel('teacher');
  const role = useUserRole();
  const myCourses = dashboardData || [];
  const studentCourses = myCourses.filter((course) => !course.canEdit);
  const editableCourses = myCourses.filter((course) => course.canEdit);

  return (
    <Page size={CONTENT_STANDARD} gap='60'>
      <HeaderSearch $hasExtraMargem={!!cartItemsCount}>
        <PageControls onClearSearch={clearSearch} onSearch={handleSearch} placeholder={t('dashboard.searchPlaceholder')} disableClear={!searchQuery} />
      </HeaderSearch>
      <PageSection>
        <WelcomeRow>
          <WelcomeMessage role={role} />
          {isTeacher || isOwner ? (
            <TeacherOverviewWidget stats={MOCK_COURSE_STATS} coursesCount={editableCourses.length} />
          ) : (
            <LearningProgressOverview courses={studentCourses} />
          )}
        </WelcomeRow>
      </PageSection>
      {isLoading && !myCourses.length ? (
        <PageSection>
          <ListCourses isLoading={true} />
        </PageSection>
      ) : (
        <>
          {(isTeacher || isOwner) && <MyTeachingList courses={myCourses} searchQuery={searchQuery} showDrafts={features.draftCourses} />}
          <MyCoursesList courses={myCourses} searchQuery={searchQuery} title={isTeacher || isOwner ? t('dashboard.myLearning') : t('dashboard.myCourses')} />
          {features.coursioNetwork && (
            <>
              <NetworkUpsells />
              <NetworkSuggestions searchQuery={searchQuery} />
            </>
          )}
        </>
      )}
    </Page>
  );
};

export default DashboardContent;
